export default __webpack_public_path__ + "static/media/PhoneCall.b30442c5.svg";